import React from 'react';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import {
  TripMatch, TripRequest,
} from '@marageti/z4-sdk/lib/travel';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import { useParams } from 'react-router-dom';
import TripSecondaryAppbarView from './trip-match-sub-navigation-view';
import { TabItem } from '../sub-navigation/types';
import { MinimalChatIndicator } from '../list-cards/trip-indicators';

const createTripMatchLinks = (tripRequest: TripRequest, tripMatch: TripMatch): TabItem[] => [
  {
    label: 'details',
    to: 'details',
  },
  {
    label: 'messages',
    to: 'messages',
    sx: { pr: 1 },
    endAdornment: (
      <MinimalChatIndicator
        agentAssignedTo={tripMatch.assignedTo}
        teamMemberAssignedTo={tripRequest.assignedTo}
        tripMessageState={[...tripRequest.tripMessageState, ...tripMatch.tripMessageState]}
      />
    ),
  },
  {
    label: 'documents',
    to: 'documents',
  },
  {
    label: 'reviews',
    to: 'reviews',
  },
  {
    label: 'sales',
    to: 'sales',
  },
];

const getLinks = (tripRequest?: TripRequest, tripMatch?: TripMatch): TabItem[] => {
  if (!tripRequest || !tripMatch) { return []; }
  return createTripMatchLinks(tripRequest, tripMatch);
};

const TripMatchSubNavigationContainer = () => {
  const apiClient = useApiClient();
  const { tripMatchId } = useParams();
  const { data: tripMatch, mutate } = useFetch<TripMatch>(apiClient.tripMatchesClient.getTripMatch, [tripMatchId], !!tripMatchId);
  const { data: tripRequest } = useFetch<TripRequest>(apiClient.tripRequestsClient.getTripRequest, [tripMatch?.tripRequestId], !!tripMatch?.tripRequestId);
  const travelerId = tripRequest?.travelers[0].id;
  const { data: traveler } = useFetch<Traveler>(apiClient.peopleClient.getTraveler, [travelerId], !!travelerId);

  return (
    <TripSecondaryAppbarView
      tabs={getLinks(tripRequest, tripMatch)}
      tripMatch={tripMatch}
      traveler={traveler || {} as Traveler}
      onSoldCanceled={() => mutate()}
    />
  );
};

export default TripMatchSubNavigationContainer;
